import { render, staticRenderFns } from "./ReorderExperiences.vue?vue&type=template&id=673dce4e&scoped=true"
import script from "./ReorderExperiences.vue?vue&type=script&lang=js"
export * from "./ReorderExperiences.vue?vue&type=script&lang=js"
import style0 from "./ReorderExperiences.vue?vue&type=style&index=0&id=673dce4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dce4e",
  null
  
)

/* custom blocks */
import block0 from "./ReorderExperiences.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports